import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that resets scroll position on route changes AND page refresh
 * ENHANCED: Gestionează atât navigarea cât și refresh-ul
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top pentru navigare între rute
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Instant pentru a evita animația la route change
    });
  }, [pathname]);

  // Effect separat pentru gestionarea refresh-ului
  useEffect(() => {
    // Forțează scroll to top la mount (inclusiv refresh)
    window.scrollTo(0, 0);
    
    // Dezactivează scroll restoration pentru a preveni browser-ul să "amintească" poziția
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Cleanup: restaurează comportamentul default la unmount
    return () => {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'auto';
      }
    };
  }, []); // Empty dependency array - rulează doar la mount

  return null; // Această componentă nu render-ează nimic vizibil
};

export default ScrollToTop;
